import SimpleBar from "simplebar-react";
import "simplebar/src/simplebar.css";

import { makeStyles } from "@material-ui/core/styles";

import hexToRgb from "assets/theme/hex-to-rgb";

const useStyles = makeStyles((theme) => ({
  tableActions: {
    justifyContent: "flex-end",
    right: 0,
    position: "absolute",
  },
  actionsWrapper: {
    display: "flex",
    alignItems: "center",
    marginRight: 16,
    "& > .search-label": {
      marginRight: 10,
      width: "80%",
      marginBottom: 0,
    },
  },
  footerClass: {
    position: "absolute",
    "& > th": {
      background: "none",
      border: "none",
    },
  },
  tableWrapper: {
    paddingBottom: 20,
    "& > .react-bootstrap-table-pagination": {
      marginTop: 35,
    },
  },
  tableClass: {
    "& > tfoot": {
      height: 40,
      minHeight: "fit-content",
    },
  },
  scrollbarClass: {
    "& > .simplebar-wrapper": {
      paddingBottom: "1rem",
    },
    "& > .simplebar-track > .simplebar-scrollbar::before": {
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.5)`,
    },
    "&.simplebar-dragging .simplebar-track > .simplebar-scrollbar::before": {
      backgroundColor: `rgba(${hexToRgb(theme.palette.black.main)}, 0.9)`,
    },
  },
}));

function Scrollbar({ style, children }) {
  const classes = useStyles();

  return (
    <SimpleBar className={classes.scrollbarClass} style={style}>
      {children}
    </SimpleBar>
  );
}

Scrollbar.propTypes = {};

export default Scrollbar;
